.stars {
    display: flex;
    gap: 2px;
}